import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaymentSuccessPage() {
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const tries = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) {
      setState("error");
      return undefined;
    }
    let stop = false;
    const poll = async () => {
      if (stop) return;
      tries.current += 1;
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          return;
        }
        if (["failed", "expired"].includes(data.payment_status)) {
          setState("error");
          return;
        }
      } catch (err) {
        console.error("Payment status poll failed", err);
      }
      if (tries.current >= 10) setState("pending");
      else setTimeout(poll, 2000);
    };
    poll();
    return () => {
      stop = true;
    };
  }, []);

  const copy = {
    checking: ["Confirming your payment…", "One moment — we're checking with Stripe."],
    paid: ["Payment confirmed", "Your sessions have been added to your account. You're all set."],
    pending: ["Payment is processing", "It's taking a little longer than usual. Your sessions will appear automatically once it clears — check back shortly."],
    error: ["Something went wrong", "We couldn't confirm that payment. If you were charged, contact the wellness team and we'll make it right."],
  }[state];

  return (
    <main id="main" className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-success-page">
      <div className="iw-mono uppercase mb-3" style={{ color: "var(--iw-accent-red)", fontSize: "10px", letterSpacing: "0.22em", fontWeight: 600 }}>
        Payment
      </div>
      <h1 className="serif font-bold m-0 mb-4" style={{ color: "var(--iw-primary)", fontSize: "32px" }} data-testid="payment-status-title">
        {copy[0]}
      </h1>
      <p className="text-base mb-8" style={{ color: "var(--iw-body)" }} data-testid="payment-status-body">
        {copy[1]}
      </p>
      {state !== "checking" && (
        <a href="/dashboard" className="iw-btn-primary" data-testid="payment-goto-dashboard">
          Go to My Progress <span aria-hidden="true">↗</span>
        </a>
      )}
    </main>
  );
}

export function PaymentCancelPage() {
  return (
    <main id="main" className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <h1 className="serif font-bold m-0 mb-4" style={{ color: "var(--iw-primary)", fontSize: "32px" }}>
        Checkout cancelled
      </h1>
      <p className="text-base mb-8" style={{ color: "var(--iw-body)" }}>
        No charge was made. You can purchase sessions any time from your My Progress page.
      </p>
      <a href="/dashboard" className="iw-btn-primary" data-testid="payment-cancel-dashboard">
        Back to My Progress <span aria-hidden="true">↗</span>
      </a>
    </main>
  );
}
